import { render, staticRenderFns } from "./TransferRecord.vue?vue&type=template&id=f529f688&"
import script from "./TransferRecord.vue?vue&type=script&lang=js&"
export * from "./TransferRecord.vue?vue&type=script&lang=js&"
import style0 from "./TransferRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports